import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FiveStars } from '../../assets/images/icons/five_stars_black.svg';
import { CheckIcon, CrossIcon } from '../CompareV2/CompareIcons';
import { AttrValue, DESKTOP_DEFAULT, NO, PRODUCTS, SECTIONS, YES } from '../CompareV2/compareData';
import { PressReviewData } from '../ReviewsCarousel/ReviewData';
import styles from './HardwareFirstSoloSections.module.scss';

function Value({ value }: { value: AttrValue }) {
  const { t } = useTranslation();
  if (value === YES || value === NO) {
    const yes = value === YES;
    return (
      <span className={yes ? styles.yes : styles.no}>
        {yes ? <CheckIcon /> : <CrossIcon />}
        <span className={styles.yesNoLabel}>{t(yes ? 'compare_v2_yes' : 'compare_v2_no')}</span>
      </span>
    );
  }
  return (
    <span className={styles.spec}>
      {t(value.valueKey)}
      {value.subKey && <span className={styles.specSub}>{t(value.subKey)}</span>}
    </span>
  );
}

/** The compare page's rows, inline under the quiz band, for the three dog trackers. */
export function SoloCompareTable() {
  const { t } = useTranslation();
  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th />
            {DESKTOP_DEFAULT.map((key) => (
              <th key={key}>{t(PRODUCTS[key].nameKey)}</th>
            ))}
          </tr>
        </thead>
        {SECTIONS.map((section) => (
          <tbody key={section.titleKey}>
            <tr className={styles.sectionRow}>
              <th colSpan={DESKTOP_DEFAULT.length + 1}>{t(section.titleKey)}</th>
            </tr>
            {section.rows.map((row) => (
              <tr key={row.attrKey}>
                <th>{t(row.labelKey)}</th>
                {DESKTOP_DEFAULT.map((key) => (
                  <td key={key}>
                    <Value value={PRODUCTS[key].attrs[row.attrKey]} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        ))}
      </table>
    </div>
  );
}

/** The s3+ pdp's press quotes as cards: stars, the pull quote, the publication's name. */
export function SoloPressReviews() {
  const { t } = useTranslation();
  return (
    <ul className={styles.press}>
      {PressReviewData.map(({ author, quote }) => (
        <li key={author.name} className={styles.pressCard}>
          <FiveStars className={styles.pressStars} />
          <p className={styles.pressQuote}>{t(quote)}</p>
          <span className={styles.pressBy}>{author.name}</span>
        </li>
      ))}
    </ul>
  );
}
